import { theme } from "../../Methods/theme";

const initState = {
  lang: 'fa',
  theme,
};

export default function Reducer(state = initState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
